"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
// import {Player} from '@idp/gvp';
require("./GVPDemo.css");
var GVPDemo = /** @class */ (function (_super) {
    __extends(GVPDemo, _super);
    function GVPDemo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GVPDemo.prototype.render = function () {
        return (React.createElement("div", { "data-test-id": this.props.testId },
            "GVPDemo Component",
            this.props.children));
    };
    return GVPDemo;
}(React.Component));
exports.default = GVPDemo;
//# sourceMappingURL=GVPDemo.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/GVP/GVPDemo/GVPDemo.js
// module id = 1027
// module chunks = 8